import type { WordTimestamp } from '@/types/conversation.types';

export function parseTranscriptJson(raw: string | undefined): WordTimestamp[] | null {
  const trimmed = raw?.trim();
  if (!trimmed) return null;
  try {
    const data = JSON.parse(trimmed) as unknown;
    if (!Array.isArray(data) || data.length === 0) return null;
    return data as WordTimestamp[];
  } catch {
    return null;
  }
}

// Approximation when ElevenLabs timestamps are unavailable — distributes audio duration evenly across words.
export function buildSyntheticWordTimestamps(text: string, durationSec: number): WordTimestamp[] {
  const words = text.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0 || durationSec <= 0 || Number.isNaN(durationSec)) return [];
  const slice = durationSec / words.length;
  return words.map((w, i) => ({
    word: w,
    start: i * slice,
    end: (i + 1) * slice,
  }));
}
